import $ from 'jquery';
import 'bootstrap-input-spinner';

$('.shop-widgets-toggle').on('click', function () {
    $('.shop-widgets').toggleClass('shop-widgets-active');
});

const p = 'p.price';
const q = $(p).html();

$('form.variations_form')
    .on('show_variation', function (event, data) {
        if (data.price_html) {
            $(p).html(data.price_html);
        }
    })
    .on('hide_variation', function () {
        $(p).html(q);
    });

const inputSpinner = () => {
    $('.cart input[type="number"]').inputSpinner({
        groupClass: 'input-spinner',
        incrementButton: '<i class="vipers-icons-up"></i>',
        decrementButton: '<i class="vipers-icons-down"></i>',
        buttonsWidth: '30px',
    });
};

inputSpinner();

$(document.body).on('updated_wc_div', inputSpinner);

$(document).on('click', '.woocommerce-notice-dismiss', function () {
    $(this).parents('.woocommerce-message').remove();
});
